import { IApiBaseProps } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import { EProjectTwcGeRequestApplicationType } from './projectTwcGeRequest.constants';
import { IProjectTwcGeRequest, IUpsertProjectTwcGeRequestRequest } from './projectTwcGeRequest.models';

export const apiRoutes = {
  getAllProjectTwcGeRequests: '/ProjectTwcGeRequests',
  getProjectTwcGeRequestById: (id: number) => `/ProjectTwcGeRequests/${id}`,
  saveProjectTwcGeRequestAsDraft: '/ProjectTwcGeRequests/Draft',
  issueProjectTwcGeRequestToPm: '/ProjectTwcGeRequests/IssueToPm',
  approveProjectTwcGeRequestByPm: '/ProjectTwcGeRequests/ApproveByPm',
  approveProjectTwcGeRequestByEm: '/ProjectTwcGeRequests/ApproveByEm',
  approveProjectTwcGeRequestByHoe: '/ProjectTwcGeRequests/ApproveByHoe',
  cancelProjectTwcGeRequest: (id: number) => `/ProjectTwcGeRequests/${id}/Cancel`,
  revokeProjectTwcGeRequest: (id: number) => `/ProjectTwcGeRequests/${id}/Revoke`,
};

export interface IGetAllProjectTwcGeRequestProps extends IApiBaseProps {
  applicationType: EProjectTwcGeRequestApplicationType;
}

export const getAllProjectTwcGeRequestsAsync = async (
  props: IGetAllProjectTwcGeRequestProps,
): Promise<IPagedResultsV1<IProjectTwcGeRequest>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getAllProjectTwcGeRequests}`,
    {
      params: props,
    },
  );
  return result.data;
};

export interface IGetProjectTwcRequestByIdAsyncProps extends IApiBaseProps {
  id: number;
}

export const getProjectTwcGeRequestByIdAsync = async (
  props: IGetProjectTwcRequestByIdAsyncProps,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerGet<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectTwcGeRequestById(props.id)}`,
    {
      params: props,
    },
  );
  return result.data;
};

export const saveProjectTwcGeRequestAsDraftAsync = async (
  props: IUpsertProjectTwcGeRequestRequest,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPost<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.saveProjectTwcGeRequestAsDraft}`,
    props,
  );
  return result.data;
};

export const issueProjectTwcGeRequestToPmAsync = async (
  props: IUpsertProjectTwcGeRequestRequest,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPost<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.issueProjectTwcGeRequestToPm}`,
    props,
  );
  return result.data;
};

export const approveProjectTwcGeRequestByPmAsync = async (
  props: IUpsertProjectTwcGeRequestRequest,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPut<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.approveProjectTwcGeRequestByPm}`,
    props,
  );
  return result.data;
};

export const approveProjectTwcGeRequestByEmAsync = async (
  props: IUpsertProjectTwcGeRequestRequest,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPut<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.approveProjectTwcGeRequestByEm}`,
    props,
  );
  return result.data;
};

export const approveProjectTwcGeRequestByHoeAsync = async (
  props: IUpsertProjectTwcGeRequestRequest,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPut<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.approveProjectTwcGeRequestByHoe}`,
    props,
  );
  return result.data;
};

export interface IProjectTwcGeRequestStatusChangeProps extends IApiBaseProps {
  id: number;
  applicationType: EProjectTwcGeRequestApplicationType;
}

export const cancelProjectTwcGeRequestAsync = async (
  props: IProjectTwcGeRequestStatusChangeProps,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPut<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.cancelProjectTwcGeRequest(props.id)}`,
    undefined,
    {
      params: props,
    },
  );
  return result.data;
};

export const revokeProjectTwcGeRequestAsync = async (
  props: IProjectTwcGeRequestStatusChangeProps,
): Promise<IItemResponse<IProjectTwcGeRequest>> => {
  const result = await apiServerPut<IItemResponse<IProjectTwcGeRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.revokeProjectTwcGeRequest(props.id)}`,
    undefined,
    {
      params: props,
    },
  );
  return result.data;
};
